import { Col, Row } from 'antd';
import clx from 'classnames';
import type * as React from 'react';
import styled from 'styled-components';

const LabelCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
  &.label-align-left {
    justify-content: flex-start;
    width: auto;
  }
`;
const DataCol = styled(Col)`
  display: flex;
  padding: 8px 0;
  &.data-align-center-vertical {
    align-items: center;
  }
`;
const DataRow = styled(Row)`
  &.show-lines {
    border-bottom: 1px solid #e8e8e8;
    &:first-child {
      border-top: 1px solid #e8e8e8;
    }
  }
`;

export interface LabelValueLineProps {
  label?: React.ReactNode;
  value?: React.ReactNode;
  labelSpan?: number;

  dataAlignCenterVertical?: boolean;
  labelAlignLeft?: boolean;
  showLines?: boolean;

  verticalLayout?: boolean | null;

  styles?: {
    row?: React.CSSProperties;
    label?: React.CSSProperties;
    value?: React.CSSProperties;
  };
}

/**
 * Semlice riga per visualizzazione di una label e un valore
 */
export function LabelValueLine(props: LabelValueLineProps) {
  const {
    label,
    value,
    labelSpan = 8,
    dataAlignCenterVertical = false,
    labelAlignLeft = false,
    showLines = true,
    verticalLayout = false,
    styles,
  } = props;

  return (
    <DataRow
      style={styles?.row}
      className={clx({ 'show-lines': showLines })}
      gutter={18}
      align="middle"
    >
      <LabelCol
        style={styles?.label}
        className={clx({ 'label-align-left': labelAlignLeft })}
        span={verticalLayout ? 24 : labelSpan}
      >
        {label}
      </LabelCol>
      <DataCol
        style={styles?.value}
        className={clx({
          'data-align-center-vertical': dataAlignCenterVertical,
        })}
        span={verticalLayout ? 24 : 24 - labelSpan}
      >
        {value}
      </DataCol>
    </DataRow>
  );
}
